import styled from 'styled-components';

type Props = {
  sponly?: boolean;
};

export const Br = styled.br<Props>`
  ${({ theme, sponly }) => {
    return {
      ...theme.screen.sp({
        display: sponly ? 'block' : 'none',
      }),
      ...theme.screen.pc({
        display: sponly ? 'none' : 'block',
      }),
    };
  }}
`;
